// RecordingPage.js
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { API } from '../../shared/api/Api';
import { useSelector } from 'react-redux';
import { selectUserInformations } from '../../features/authSlice';
import { showToast } from '../../utils/utils';
import RecordingTable from '../../components/Tables/RecordingTable';

const DEBOUNCE_DELAY = 700;

const RecordingPage = () => {
    const [records, setRecords] = useState([]);
    const [loader, setLoader] = useState(false);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
    });
    const user = useSelector(selectUserInformations);

    const fetchRecords = async () => {
        setLoader(true)
        try {
            const { data } = await axios.get(API.Courses.app_courses_live_records_all, {
                headers: {
                    Authorization: `Bearer ${user.token}`
                },
                params: {
                    search: debouncedSearch,
                    page: pagination.current_page
                }
            });

            if (data.status === 200) {
                setRecords(data.data.items);
                setPagination({
                    current_page: data.data.current_page,
                    last_page: data.data.last_page,
                });
            } else {
                showToast('Oops, there is an error', data.message, 'error');
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }

    // Search effect
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);

            setPagination(prev => ({ ...prev, current_page: 1 }));
        }, DEBOUNCE_DELAY);

        return () => clearTimeout(handler);
    }, [search]);

    // Fetch when debounced search or page changes
    useEffect(() => {
        fetchRecords()
    }, [debouncedSearch, pagination.current_page]);

    const handlePageChange = (direction) => {
        setPagination(prev => ({
            ...prev,
            current_page: direction === 'next'
                ? Math.min(prev.current_page + 1, prev.last_page)
                : Math.max(1, prev.current_page - 1)
        }));
    }

    return (
        <div className='min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6'>
            <RecordingTable
                records={records}
                loader={loader}
                search={search}
                handleSearchChange={(e) => setSearch(e.target.value)}
                currentPage={pagination.current_page}
                totalPages={pagination.last_page}
                onPageChange={handlePageChange}
            />
        </div>
    )
}

export default RecordingPage